import type { AnalyticState } from './types';

export const initialState: AnalyticState = {
	createAnalyticsEvent: undefined,
};
